"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthButtonsPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("../../atoms");
const providers_1 = require("../../providers");
function AuthButtonsPanel({ className, }) {
    return ((0, jsx_runtime_1.jsx)(providers_1.AuthProvider, { "data-e2e": 'AuthButtonsPanel_AuthProvider', children: (0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'AuthButtonsPanel_Container', children: [(0, jsx_runtime_1.jsx)(atoms_1.SignInButton, { "data-e2e": 'AuthButtonsPanel_SignInButton' }), (0, jsx_runtime_1.jsx)(atoms_1.RegisterButton, { "data-e2e": 'AuthButtonsPanel_RegisterButton' })] }) }));
}
exports.AuthButtonsPanel = AuthButtonsPanel;
const Container = styled_components_1.default.div `
  display: flex;
  gap: 8px;
`;
